import { Platform, Dimensions } from 'react-native';

const { width } = Dimensions.get('window'),
    isDesktop = Platform.OS === 'web' && width > 720;

export default {
    isDesktop,
    fontSize: isDesktop ? 16 : 12,
    statusBar: Platform.OS === 'ios' ? 20 : 0,
    gutterMin: 4,
    gutterSmall: 8,
    gutterMedium: 12,
    gutter: 16,
    gutterBig: 20,
    gutterLarge: 24,
    baseRadius: 6,
    radius: 8,
    gutterDM: isDesktop ? 8 : 4,
    heightDM: isDesktop ? '40px' : '45px',
    lineHeightDM: isDesktop ? '36px' : ''
};
